/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keepWithinBoundaries = exports.isTopMostCoordinate = exports.isRightMostCoordinate = exports.isLeftMostCoordinate = exports.isCoordinateInArea = exports.isBottomMostCoordinate = exports.inverse = exports.getSurroundingArea = exports.getPositionForCoordinate = exports.getOffsetCoordinate = exports.getNextCoordinateUp = exports.getNextCoordinateRight = exports.getNextCoordinateLeft = exports.getNextCoordinateDown = exports.getMovementDirection = exports.getDimensionsForArea = exports.getCoordinatesForArea = exports.getCoordinateInfo = exports.coordinateToDataRange = exports.areEqual = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _times2 = _interopRequireDefault(require("lodash/times"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var isCoordinateInArea = function isCoordinateInArea(_ref, area) {
  var x = _ref.x,
    y = _ref.y;
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!area) {
    return fallback;
  }
  var xFrom = area.xFrom,
    xTo = area.xTo,
    yFrom = area.yFrom,
    yTo = area.yTo;
  return x >= Math.floor(xFrom) && x <= Math.ceil(xTo) && y >= Math.floor(yFrom) && y <= Math.ceil(yTo);
};
exports.isCoordinateInArea = isCoordinateInArea;
var getCoordinateInfo = function getCoordinateInfo(_ref2) {
  var x = _ref2.x,
    y = _ref2.y;
  var coordinateData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _get2["default"])(coordinateData, [y, x]);
};
exports.getCoordinateInfo = getCoordinateInfo;
var getCoordinatesForArea = function getCoordinatesForArea() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    xFrom = _ref3.xFrom,
    xTo = _ref3.xTo,
    yFrom = _ref3.yFrom,
    yTo = _ref3.yTo;
  var rowCount = Math.ceil(yTo) - Math.floor(yFrom) + 1;
  var columnCount = Math.ceil(xTo) - Math.floor(xFrom) + 1;
  var coordinates = [];
  (0, _times2["default"])(rowCount, function (rowIndex) {
    (0, _times2["default"])(columnCount, function (columnIndex) {
      coordinates.push({
        x: xFrom + columnIndex,
        y: yFrom + rowIndex
      });
    });
  });
  return coordinates;
};
exports.getCoordinatesForArea = getCoordinatesForArea;
var keepWithinBoundaries = function keepWithinBoundaries(coordinate, boundaries) {
  var x = coordinate.x,
    y = coordinate.y;
  var xFrom = boundaries.xFrom,
    xTo = boundaries.xTo,
    yFrom = boundaries.yFrom,
    yTo = boundaries.yTo;
  return {
    x: Math.min(Math.max(xFrom, x), xTo),
    y: Math.min(Math.max(yFrom, y), yTo)
  };
};
exports.keepWithinBoundaries = keepWithinBoundaries;
var areEqual = function areEqual(coordinateA, coordinateB) {
  return coordinateA && coordinateB && coordinateA.x === coordinateB.x && coordinateA.y === coordinateB.y;
};
exports.areEqual = areEqual;
var getOffsetCoordinate = function getOffsetCoordinate(coordinate, delta) {
  var multiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var xStep = delta.xStep,
    yStep = delta.yStep;
  var x = coordinate.x,
    y = coordinate.y;
  return {
    x: x + xStep * multiplier,
    y: y + yStep * multiplier
  };
};
exports.getOffsetCoordinate = getOffsetCoordinate;
var getSurroundingArea = function getSurroundingArea(coordinate) {
  var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var coordinateRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var x = coordinate.x,
    y = coordinate.y;
  var count = coordinateRatio + distance * 2;
  var xFrom = Math.round(x) - distance;
  var yFrom = Math.round(y) - distance;
  var xTo = xFrom + count - 1;
  var yTo = yFrom + count - 1;
  return {
    xFrom: xFrom,
    xTo: xTo,
    yFrom: yFrom,
    yTo: yTo
  };
};
exports.getSurroundingArea = getSurroundingArea;
var getDimensionsForArea = function getDimensionsForArea(area, tileDimensions) {
  var xFrom = area.xFrom,
    xTo = area.xTo,
    yFrom = area.yFrom,
    yTo = area.yTo;
  var rowCount = yTo - yFrom + 1;
  var columnCount = xTo - xFrom + 1;
  return {
    width: columnCount * tileDimensions.width,
    height: rowCount * tileDimensions.height
  };
};
exports.getDimensionsForArea = getDimensionsForArea;
var getPositionForCoordinate = function getPositionForCoordinate(coordinate, tileDimensions) {
  var x = coordinate.x,
    y = coordinate.y;
  var width = tileDimensions.width,
    height = tileDimensions.height;
  return {
    left: x * width,
    top: y * height
  };
};
exports.getPositionForCoordinate = getPositionForCoordinate;
var inverse = function inverse(_ref4) {
  var x = _ref4.x,
    y = _ref4.y;
  return {
    x: -Number(x),
    y: -Number(y)
  };
};
exports.inverse = inverse;
var coordinateToDataRange = function coordinateToDataRange(_ref5, range) {
  var x = _ref5.x,
    y = _ref5.y;
  var xFrom = range.xFrom + x * (range.xStep || 1);
  var xTo = xFrom + range.xStep;
  var yFrom = range.yFrom + y * (range.yStep || 1);
  var yTo = yFrom + range.yStep;
  return {
    xFrom: xFrom,
    xTo: xTo,
    yFrom: yFrom,
    yTo: yTo
  };
};
exports.coordinateToDataRange = coordinateToDataRange;
var isLeftMostCoordinate = function isLeftMostCoordinate(_ref6, _ref7) {
  var x = _ref6.x;
  var xFrom = _ref7.xFrom;
  return xFrom >= x;
};
exports.isLeftMostCoordinate = isLeftMostCoordinate;
var isRightMostCoordinate = function isRightMostCoordinate(_ref8, _ref9) {
  var x = _ref8.x;
  var xTo = _ref9.xTo;
  return xTo <= x;
};
exports.isRightMostCoordinate = isRightMostCoordinate;
var isTopMostCoordinate = function isTopMostCoordinate(_ref10, _ref11) {
  var y = _ref10.y;
  var yFrom = _ref11.yFrom;
  return yFrom >= y;
};
exports.isTopMostCoordinate = isTopMostCoordinate;
var isBottomMostCoordinate = function isBottomMostCoordinate(_ref12, _ref13) {
  var y = _ref12.y;
  var yTo = _ref13.yTo;
  return yTo <= y;
};
exports.isBottomMostCoordinate = isBottomMostCoordinate;
var getNextCoordinateLeft = function getNextCoordinateLeft(_ref14) {
  var x = _ref14.x,
    y = _ref14.y;
  return {
    x: x - 1,
    y: y
  };
};
exports.getNextCoordinateLeft = getNextCoordinateLeft;
var getNextCoordinateRight = function getNextCoordinateRight(_ref15) {
  var x = _ref15.x,
    y = _ref15.y;
  return {
    x: x + 1,
    y: y
  };
};
exports.getNextCoordinateRight = getNextCoordinateRight;
var getNextCoordinateUp = function getNextCoordinateUp(_ref16) {
  var x = _ref16.x,
    y = _ref16.y;
  return {
    x: x,
    y: y - 1
  };
};
exports.getNextCoordinateUp = getNextCoordinateUp;
var getNextCoordinateDown = function getNextCoordinateDown(_ref17) {
  var x = _ref17.x,
    y = _ref17.y;
  return {
    x: x,
    y: y + 1
  };
};
exports.getNextCoordinateDown = getNextCoordinateDown;
var getMovementDirection = function getMovementDirection(from, to) {
  if (from.x > to.x) {
    return 'left';
  }
  if (from.x < to.x) {
    return 'right';
  }
  if (from.y > to.y) {
    return 'up';
  }
  if (from.y < to.y) {
    return 'down';
  }
  return '';
};
exports.getMovementDirection = getMovementDirection;